<template>
  <div class="top-image-box" v-if="imgList && imgList.length">
    <img class="image" v-if="imgList.length === 1" :src="imgList[0].moduleDetailValue" mode="widthFix"/>
    <van-swipe v-else indicator-color="white">
      <van-swipe-item  v-for="(item, index) in imgList" :key="index">
        <img class="image" :src="item.moduleDetailValue" mode="widthFix" />
      </van-swipe-item>
    </van-swipe>
  </div>
  <div class="card" v-else>
    <img class="img-demo" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/CD/rB8LrmU5vVmARSvcAADUOgAyVFc006.png" alt="">
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
}
</script>

<style lang="stylus" scoped>
.top-image-box
  height: 100%
  overflow hidden
  font-size 0
  .image
    width 100%
    height auto
.card
  font-size 0
  .img-demo
    width 100%;
    height: 245px
</style>